import { Component, OnInit, Input } from '@angular/core';

import { CampaignService } from '../../services/campaign.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.html',
  styleUrls: ['./articles.component.scss']
})
export class TermsComponent implements OnInit {

  constructor(public CampSvc:CampaignService) { }

  ngOnInit(): void {
  }

  closeSection(){
	  this.CampSvc.currentState=this.CampSvc.previousState;
	  this.scrollToElement(this.CampSvc.currentState);
  }
	scrollToElement(anchor): void {
		var element=document.getElementById(anchor);
		setTimeout(()=> { element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});}, 200);
	}
}
